import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { BASE_DIALOG_CLASSNAME } from './base-modal-dialog-utils.js';

/**
 * This is a base component that should not be used directly in the web app.
 * Use `MDialog` instead.
 *
 * @deprecated Use `MDialog` instead
 */
function BaseModalDialog({ open, onClose, content, }) {
    const dialogRef = useRef(null);
    useEffect(() => {
        if (!dialogRef.current) {
            return;
        }
        if (open) {
            dialogRef.current.showModal();
            document.body.style.overflowY = "hidden";
        }
        else {
            dialogRef.current.close();
            // We should only re-add the scrollbar when no other dialogs are rendered
            // For example when nesting dialogs
            if (!document.querySelector(`.${BASE_DIALOG_CLASSNAME}[open]`)) {
                document.body.style.overflowY = "";
            }
        }
        return () => {
            // We should only re-add the scrollbar when no other dialogs are rendered
            // For example when nesting dialogs
            if (!document.querySelector(`.${BASE_DIALOG_CLASSNAME}[open]`)) {
                document.body.style.overflowY = "";
            }
        };
    }, [open]);
    return (jsx(StyledDialog, { className: BASE_DIALOG_CLASSNAME, ref: dialogRef, onClick: (e) => {
            if (dialogRef.current && e.target === dialogRef.current) {
                onClose();
            }
        }, onCancel: (e) => {
            e.stopPropagation();
            onClose();
        }, role: "dialog", children: content }));
}
const StyledDialog = styled.dialog `
  position: fixed;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  max-width: none;
  max-height: none;
  background: none;
  border: none;

  &[open] {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &::backdrop {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export { BaseModalDialog };
